import React, { useEffect, useState } from "react";
import "./FAQPage.css";
 
const genesysFaqData = [
  {
    question:
      "Why is the Genesys Organization Name required?",
    answer:
      "The Genesys Organization Name is used to accurately identify and connect to your Genesys Cloud environment. It ensures that the data migration process targets the correct organization and avoids any cross-environment access issues.",
    isOpen: false,
  },
  {
    question:
      "What is the significance of the Genesys Region in the migration process?",
    answer:
      "The Genesys Region determines the appropriate API endpoint for your environment. Since Genesys Cloud operates in multiple geographic regions, specifying the correct region is essential to establish a secure and successful connection to your instance.",
    isOpen: false,  
  },
  {
    question:
      "What is the purpose of providing the Client ID?",
    answer:
      "The Client ID is part of the OAuth authentication mechanism in Genesys Cloud. It identifies the application (in this case, the migration utility) that is requesting access to your environment's data via secure APIs.",
    isOpen: false,
  },
  {
    question:
      "Why do you require the Client Secret?",
    answer:
      "The Client Secret, used in conjunction with the Client ID, enables secure authentication to Genesys Cloud. It is required to obtain an access token, which is necessary to authorize API requests for retrieving users, queues, routing profiles, and other configuration data.",
    isOpen: false,
  },
  {
    question:"  Are the provided credentials (Client ID and Secret) handled securely?",
    answer:"Yes. All credentials are handled with strict confidentiality and are used solely for the duration of the migration process. It is recommended that a temporary OAuth client with minimal required permissions be created specifically for this purpose, and subsequently revoked upon completion of the migration.",
    isOpen:false,
  },
  // {
  //   question:"How do I choose between Connectgen Account and Customer Account installations?",
  //   answer:" The choice between Connectgen Account and Customer Account installations depends on factors such as security, resource needs, budget, and scalability. Consider your organization's specific requirements and consult with your IT team or provider for guidance.",
  //   isOpen:false,
  // },
  // {
  //   question:
  //     "What is the region selection option for?",
  //   answer:
  //     "The region selection option allows customers to choose the geographic region where they want to deploy their contact center resources.",
  //   isOpen: false,
  // },
  // {
  //   question:
  //     "Can I change the region of my contact center after it's been deployed?",
  //   answer:
  //     "In some cases, it may be possible to migrate your contact center to a different region, but this process can involve downtime and data migration. It's best to plan your region selection carefully from the outset to avoid unnecessary disruptions.",
  //   isOpen: false,
  // },
  // {
  //   question:
  //     "Can I enter the short form of my organization in the “What is your organization name” section?",
  //   answer:
  //     "No, you cannot enter the short form of your organization in this section. The organization name that you give plays an important role in your contact center. Hence, it is required to give a proper full name of your organization.",
  //   isOpen: false,
  // },
  // {
  //   question: "What is an access URL?",
  //   answer:
  //     "An access URL is a web address that allows you to visit or access your contact center on the internet.",
  //   isOpen: false,
  // },
  // {
  //   question: "Can I customize my access URL to reflect my organization?",
  //   answer:
  //     "Yes, customization of the access URL can be done by editing the URL inside the text box.",
  //   isOpen: false,
  // },
  // {
  //   question: "Is this access URL permanent, or can it be changed later?",
  //   answer: "Access URL once created cannot be changed.",
  //   isOpen: false,
  // },
  // {
  //   question: "What is the “Check Availability” button for?",
  //   answer:
  //     "This button checks for the uniqueness of your Access URL. If any access URLs are same as your Access URL, it shows an error. If your Access URL is unique, it displays “This URL is available” and you can proceed further.",
  //   isOpen: false,
  // },
  // {
  //   question: "What are “Call and chatbot options”?",
  //   answer:
  //     "This section displays the call and chatbot features you want to have for your contact center. If you want to allow incoming calls for your contact center, turn on the toggle button for incoming calls. Similarly, if you want to make outgoing calls from your contact center, turn on the toggle button for outgoing calls. If you want to add a chatbot that answers questions to your website, please turn on the toggle button for the Chatbot.",
  //   isOpen: false,
  // },
  // {
  //   question:
  //     "Why is a domain URL required for creating a chatbot in my application?",
  //   answer:
  //     "A domain URL is needed to host and access your chatbot within your application's environment. It provides a unique web address for users to interact with the chatbot.",
  //   isOpen: false,
  // },
  // {
  //   question:
  //     "What format should the domain URL follow?",
  //   answer:
  //     "The domain URL should be in the format “www.example.com” or “example.com”, where “example” is your chosen domain name.",
  //   isOpen: false,
  // },
  // {
  //   question:
  //     "What are the valid domain extensions accepted for the URL?",
  //   answer:
  //     "Valid domain extensions include .com, .co, .in, .info, .net, .org, .digital, .biz, and .online. If your desired domain extension is not listed, reach out to our team.",
  //     isOpen: false,
  // },
  // {
  //   question:"",
  //   answer:"",
  //   isOpen:false,
  // }
];
const awsFaqData = [
  {
    question:
      "Why are you asking for my AWS Account Number and Region?",
    answer:
      "We need your AWS Account Number to ensure we are migrating your data to the correct AWS environment. The Region (like us-east-1 or ap-south-1) tells us where your Amazon Connect instance is hosted, so we can deploy users, queues, and profiles to the right location without errors or delays.",
    isOpen: false,
  },
  {
    question:
      "What is the Amazon Connect Instance ID, and why do you need it?",
    answer:
      "The Instance ID is a unique identifier for your Amazon Connect setup. It ensures that all migrated resources — such as agents, routing profiles, and security profiles — are applied to your specific Connect environment. Without it, we can't correctly link the configurations to your system.",
    isOpen: false,  
  },
  {
    question:
      "What is the IAM Role ARN and why is it required for this migration?",
    answer:
      "The IAM Role ARN gives our migration tool temporary access to create or update resources in your Amazon Connect account. This role must have permission to manage users, queues, routing profiles, and more — but rest assured, it only operates within the limits you define.",
    isOpen: false,
  },
  {
    question:
      "What is the Customer Profiles Domain, and do I need to provide it?",
    answer:
      "The Customer Profiles Domain is needed only if you're using Amazon Connect Customer Profiles to manage customer data. It helps us migrate customer-related information like contact history and preferences into your AWS domain, keeping your data connected and consistent.",
    isOpen: false,
  },
  {
    question:" Is it safe to share these AWS details with you?",
    answer:"Yes — your security is our top priority. We use these details only to perform the migration and never store or share them beyond this process. We recommend using a secure channel to share this information, and we’re happy to guide you through setting up temporary roles and permissions that can be revoked after the migration is complete.",
    isOpen:false,
  },
  // {
  //   question: "How long does it take to activate a claimed phone number?",
  //   answer: "Phone number activation can occur instantly.",
  //   isOpen: false,
  // },
];
 
const migrationFaqData = [
  {
    question: " How do I know if all queue-related metrics from Genesys have been successfully migrated and mapped to Amazon Connect?",
    answer:
      "All queue-related metrics are systematically extracted from Genesys and validated during the migration process. Each metric—such as queue names, routing profiles, and contact handling statistics—is mapped to its equivalent structure in Amazon Connect. Verification steps and reconciliation checks are in place to ensure completeness and accuracy before making the data visible in the UI.",
    isOpen: false,
  },
  {
    question: "Are the displayed metrics such as agent answer rate, non-response rate, and average handle time accurate and updated in real time during migration?",
    answer:
      "Yes, the metrics displayed—including agent answer rate, non-response, and handle time—are derived from the most recent available data. During the migration process, real-time or near-real-time sync ensures metrics reflect the latest state from Genesys and are aligned with live operational data in Amazon Connect.",
    isOpen: false,
  },
  {
    question: "Does the migration maintain historical performance data for queues, or does it only start tracking from the point of migration?",
    answer: "The migration includes historical queue performance data based on the available export from Genesys. We ensure this data is imported and represented in Amazon Connect for continuity. However, real-time tracking and metric updates begin from the point of full system switchover to Amazon Connect.",
    isOpen: false,
  },
  {
    question: "How is the integrity of queue-specific configurations such as routing profiles and service levels ensured in Amazon Connect after migration?",
    answer:
      "Queue configurations including routing profiles, service levels, and other operational parameters are mapped and validated against Amazon Connect’s structure. Automated tools and manual verification ensure that these configurations retain their intended logic and behavior post-migration, minimizing any disruption in call flow or agent assignment.",
    isOpen: false,
  },
  {
    question:"Can I validate the accuracy of contact handling metrics—like transfers, holds, and disconnects—after migration to confirm parity with Genesys data?",
    answer:"Yes, each contact handling metric—such as contacts held, transferred (internal/external), and disconnects—is tracked and displayed in the UI. These are compared against the original Genesys records during migration. Detailed logs and exportable reports are available to help customers verify metric parity and investigate discrepancies if needed.",
    isOpen:false,
  },
  // {
  //   question:"Why should I provide alternate emails? ",
  //   answer:" Providing alternate emails ensures that you receive important messages even if there is an issue with your primary email address. It helps in maintaining uninterrupted communication.",
  //   isOpen:false,
  // },
];
 
const metricSelectionFaqData = [
  {
    question: "What does this page show me?",
    answer:
      "This page provides access to the metrics that have been successfully migrated from Genesys. Because we’ve migrated these details, you can now view them here by clicking on any of the four buttons—Queue Metrics, Agent Metrics, Sentiment Analysis Metrics, or Call Recording Metrics.",
    isOpen: false,
  },
  {
    question: "How are the metrics migrated from Genesys?",
    answer:
      "When users call the contact center outside of working hours, you can handle the situation by either sending them an email or playing a custom prompt for them to hear when they call.The data has been extracted from Genesys and securely migrated into our new reporting system. Each button fetches and displays the migrated data type you select, ensuring continuity and accuracy of your historical metrics.",
    isOpen: false,
  },
  {
    question: "What is the difference between the four metric categories?",
    answer:
      "Queue Metrics – Performance of queues such as wait times, call volumes, and service levels.Agent Metrics – Individual agent performance like handling time, occupancy, and productivity.Sentiment Analysis Metrics – AI-driven insights into customer emotions and satisfaction during calls.Call Recording Metrics – Access to recordings metadata, duration, and quality information.",
    isOpen: false,
  },
  {
    question: "Can I still access my old Genesys reports?",
    answer:
      "Yes. Historical reports remain stored and accessible. However, this page allows you to view the same migrated metrics directly in the new platform for consistency and ease of use.",
    isOpen: false,
  },
  {
    question:"Are the metrics updated in real time or only migrated data?",
    answer:"The page displays both migrated data from Genesys and continues to show real-time updates from the new system, depending on the type of metric. This ensures you have both historical continuity and live monitoring in one place.",
    isOpen:false,
   }
  // ,
  // {
  //   question:"What happens to call recordings after the retention period expires? ",
  //   answer:"Once the retention period expires, the call recordings will be automatically deleted from the S3 bucket. Once recordings are deleted after the retention period, they cannot be retrieved. It's important to ensure you have backups or have exported necessary recordings before they expire.",
  //   isOpen:false,
  // }
];

const queueMetricFaqData = [
  {
    question: "What information can I see for each queue?",
    answer:
      "Each queue displays detailed performance metrics such as agent answer rate, agent not answer rate, average after-contact work time, average interaction time, average handle time, and contacts handled (incoming, outgoing, and overall).",
    isOpen: false,
  },
  {
    question: "How do I view metrics for a specific queue?",
    answer:
      "Simply click on the Queue Metrics button, then select the queue name you’re interested in. The page will expand to show all the performance details for that queue.",
    isOpen: false,
  },
  {
    question: "Are these queue metrics real-time or historical?",
    answer:
      "The displayed metrics are those migrated from Genesys. Depending on the configuration, some values may also refresh periodically to reflect the most recent updates.",
    isOpen: false,
  },
  {
    question: "Can I compare performance across multiple queues?",
    answer:
      "Currently, metrics are shown one queue at a time when selected. To compare, you can view each queue individually. If you need side-by-side comparisons, exporting the data or requesting consolidated reports may be required.",
    isOpen: false,
  },
  {
    question:"Why are some metrics (like agent not answer rate or after-contact work time) important?",
    answer:"These metrics provide insights into queue efficiency and agent productivity. For example:Agent Answer/Not Answer Rate shows availability and responsiveness.Average Handle Time highlights workload and call complexity.After-Contact Work Time indicates how much effort is spent wrapping up after interactions.",
    isOpen:false,
   }
  // ,
  // {
  //   question:"What happens to call recordings after the retention period expires? ",
  //   answer:"Once the retention period expires, the call recordings will be automatically deleted from the S3 bucket. Once recordings are deleted after the retention period, they cannot be retrieved. It's important to ensure you have backups or have exported necessary recordings before they expire.",
  //   isOpen:false,
  // }
];
 
const agentMetricFaqData = [
  {
    question: "What information is available for each agent?",
    answer:
      "For every agent, you can view detailed performance metrics such as answer rate, idle time, non-response, on-contact time, non-productive time, occupancy, and total online time. These metrics provide a complete view of individual agent productivity and availability.",
    isOpen: false,
  },
  {
    question: "How do I view metrics for a specific agent?",
    answer:
      "Click on the Agent Metrics button to see the list of agents. Then, select the agent’s name to display their detailed performance metrics.",
    isOpen: false,
  },
  {
    question:
      "What does ‘Agent Occupancy’ mean?",
    answer:
      "Occupancy shows the percentage of an agent’s online time spent handling customer interactions versus being idle. It helps measure how effectively the agent’s time is being utilized.",
    isOpen: false,
  },
  {
    question: "Why might an agent have high non-productive time or non-response rate?",
    answer:
      "High non-productive time may indicate time spent on breaks, system issues, or tasks outside customer interactions. A high non-response rate often signals missed or declined contacts, which could be due to workload, technical issues, or availability settings.",
    isOpen: false,
  },
  {
    question: "Can I track an agent’s performance over time?",
    answer:
      "Yes. These metrics are migrated from Genesys, so you can view historical performance for each agent here. If needed, reports can also be generated to analyze trends over specific periods.",
    isOpen: false,
  }
  // ,
  // {
  //   question: "What is the Salesforce API Version?",
  //   answer:
  //     "The Salesforce API Version is like the version number of the tools your app uses to talk to Salesforce. You can specify which version you want your app to use. You can find this information in the Salesforce documentation or by checking your Salesforce account settings.** For further details or assistance, please refer to the guide provided.",
  //   isOpen: false,
  // },
  // {
  //   question: "What is the Salesforce Domain URL?",
  //   answer:
  //     "The Salesforce Domain URL is the web address that takes you to your Salesforce account. Its like the address of your house on the internet. You can usually find it by logging into your Salesforce account and checking the web address in your browser address bar.** For further details or assistance, please refer to the guide provided.",
  //   isOpen: false,
  // },
];

const sentimentMetricFaqData = [
  {
    question: "What information is shown under sentiment analysis for each agent",
    answer:
      "For each agent, you can see sentiment metrics such as the date of interaction, role (agent/customer), call direction (inbound/outbound), associated queue, sentiment score, and sentiment trend over time.",
    isOpen: false,
  },
  {
    question: "What does the sentiment score represent?",
    answer:   
      "The sentiment score reflects how positive, neutral, or negative a customer’s experience was during an interaction. It is generated using AI-based text and voice analysis from migrated Genesys data.",
    isOpen: false,
  },
  {
    question: "What is meant by ‘sentiment trend’?",
    answer: "The sentiment trend shows whether an agent’s interactions are becoming more positive, neutral, or negative over time. It helps track improvements or declines in customer experience.",
    isOpen: false,
  },
  {
    question: "Can I filter sentiment metrics by queue or call direction?",
    answer:
      "Yes. Since metrics also include queue and direction (inbound/outbound), you can analyze sentiment patterns based on where the call originated and which queue handled it.",
    isOpen: false,
  },
  {
    question: "How can these sentiment insights help improve performance?",
    answer:
      "Sentiment analysis highlights how customers feel during and after interactions. Managers can use this data to:Identify agents who handle difficult situations well.Provide coaching where negative trends are observed.Improve overall customer satisfaction and agent effectiveness.",
    isOpen: false,
  }
];

const callRecordingMetricFaqData = [
  {
    question:
      "What details are available for each call recording?",
    answer:
      "For every recorded interaction, you can view the interaction ID, associated queue, start time, call duration, and access the recording itself for playback or review.",
    isopen: false,
  },
  {
    question: "How do I access a specific call recording?",
    answer:
      "Click on the Call Recording Metrics button, select the agent’s name, and then choose the interaction you’re interested in. You can then play the recording.",
    isOpen: false,
  },
  {
    question:
      "Why are call recordings linked to agents?",
    answer:
      "Recordings are tied to the agent who handled the call, making it easier to analyze performance, verify compliance, or review customer interactions on an agent-by-agent basis.",
    isopen: false,
  },
  {
    question: "Why don’t I see filters for recordings on this page?",
    answer:
      "This page is designed to list recordings directly under each agent without filters. You can view recordings by selecting the agent first and then scrolling through their listed interactions.",
    isopen: false,
  },
  {
    question: "What are call recordings typically used for?",
    answer:
      "Call recordings are primarily used for quality assurance, compliance, dispute resolution, training, and performance reviews. Managers can also use them to cross-check sentiment analysis or confirm queue-related metrics.",
    isopen: false,
  }
  // ,
  // {
  //   question:
  //     "I cannot see the details of my contact center, what should I do now?",
  //   answer:
  //     "If the contact center details are not displayed, please reach out to us at: rapidconnect-support@lightgoldenrodyellow-hare-546075.hostingersite.com",
  //   isopen: false,
  // },
];
 
const FAQPage = ({ onClose }) => {
  let pathName = window.location.pathname;
  const [accordionData, setAccordionData] = useState([]);
 
  useEffect(() => {
    switch (pathName) {
      case "/Genesys-Cloud-Credentials":
        setAccordionData(genesysFaqData);
        break;
      case "/Aws-Account-Details":
        setAccordionData(awsFaqData);
        break;
      case "/Migration":
        setAccordionData(migrationFaqData);
        break;
      case "/Select-Metrics":
        setAccordionData(metricSelectionFaqData);
        break;
      case "/Queue-Metrics":
        setAccordionData(queueMetricFaqData);
        break;
      case "/Agent-Metrics":
        setAccordionData(agentMetricFaqData);
        break;
      // case "/sales-force-form":
      //   setAccordionData(agentMetricFaqData);
      //   break;
      case "/Sentiment-Analysis-Metrics":
        setAccordionData(sentimentMetricFaqData);
        break;      
      case "/CallRecording-Metrics":
        setAccordionData(callRecordingMetricFaqData);
        break;

      default:
        setAccordionData(genesysFaqData);
    }
  }, []);
 
  const toggleAccordion = (question) => {
    setAccordionData((prevData) =>
      prevData.map((item) =>
        item.question === question ? { ...item, isOpen: !item.isOpen } : item
      )
    );
  };
 
  return (
    <div className="faq-page">
      <div className="faq-content">
        {accordionData.map((item) => (
          <div key={item.question} className="panel panel-default">
            <div
              className="panel-heading"
              role="tab"
              onClick={() => toggleAccordion(item.question)}
            >
              <h4 className="panel-title">
                <a
                  role="button"
                  data-toggle="collapse"
                  aria-expanded={item.isOpen}
                  aria-controls={`collapse${item.question}`}
                >
                  {item.question}
                  <span
                    className={`collapsible-link ${item.isOpen ? "open" : ""}`}
                  ></span>
                </a>
              </h4>
            </div>
            <div
              id={`collapse${item.question}`}
              className={`panel-collapse collapse ${item.isOpen ? "in" : ""}`}
              role="tabpanel"
            >
              <div className="panel-body">
                <p className="answer">{item.answer}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
 
export default FAQPage;